import asyncLoader from 'lib/loader/async'
import requireLoader from 'lib/loader/require'


export {
  asyncLoader,
  requireLoader,
  requireLoader as default,
}
